import styled from '@emotion/styled';

export const SurfaceWidget = styled.div`
  min-width: 0;
  background: ${(p) => p.theme.surface.background};
  border: 1px solid ${(p) => p.theme.surface.border};
  border-radius: ${(p) => p.theme.surface.radius};
  box-shadow: ${(p) => p.theme.surface.shadow};
`;
